const { CXO_CATEGORY } = process.env;

const name = "CISOcamps";
const company = "CXOsync LLC";
const twitter = "cxosync";
const linkedin = "cxosyncllc";
const siteName = "ciso.cxosync.com";
const siteUrl = "https://ciso.cxosync.com";

module.exports = {
  cdn: "https://cdn.cxosync.com",
  pathPrefix: "/",
  category: CXO_CATEGORY || 0,
  title: name,
  titleAlt: name,
  logo: "static/logo/logo.png",
  favicon: "static/logo/favicon.png",
  banner: "static/logo/logo.png",
  author: name,
  themeColor: "#dc0000",
  backgroundColor: "#d3e0ff",
  twitter: `@${twitter}`,
  slogan: "Empowering Leadership",
  brand: name,
  company: company,
  audience: "CXO",
  brandBusiness: "Empowering Leadership",
  siteTitle: `${name} Events`,
  description: `${name} Events | Thought leading collaboration`,
  siteLanguage: "en",
  siteKeywords: [
    "CFO events",
    "CFO",
    "CFOchicago",
    "CFOdallas",
    "CFOlondon",
    "CFOpanel",
    "Charlie Miller",
    "Chief Information Security Officer",
    "CIO events",
    "CIO",
    "Private Dinner CFO",
    "Private Dinner CMO",
    "Private Dinner CIO",
    "Private Dinner CISO",
    "CIOmexico",
    "CIOpanel",
    "CIOseattle",
    "CISO events",
    "CISO",
    "CISOpanel",
    "CISOpanel",
    "CMO events",
    "CMO",
    "CMOpanel",
    "CXO",
    "CXOsports",
    "Event Population",
    "CXO events",
    "CXOpanel",
    "CXOsync CFO",
    "CXOsync CMO",
    "CXOsync CIO",
    "CXOsync CISO",
    "CXOsync events",
    "CXOsync",
    "events",
    "conference",
    "gala",
    "dinner",
    "private events",
    "Information Security Events",
    "infosec events",
    "itstartshere",
    "John McAfee",
    "Kevin Mitnick. Kevin Poulsen",
    "security events",
    "information security",
    "infosec events",
  ],
  countries: [
    "USA",
    "Canada",
    "UK",
    "EU",
    "LATAM",
    "Singapore",
  ],
  titles: ["CIOs", "CISOs", "CMOs", "CFOs"],
  hashtags: [name],
  url: siteUrl,
  siteUrl: siteUrl,
  siteName: siteName,
  adminEmail: "rupenp+admin@cxosync.com",
  noreplayEmail: "noreply@" + siteName,
  founder: "Nepal Patel",
  foundingDate: "2019",
  googleVerification: "85CLXYFrqzXBc3mUUWVTEI1pIiowqx5UyAmljYQvgMc",
  googleCookieDomain: `.${siteName}`,
  googleRecaptchaSiteKey: "6Ld_t9UUAAAAAKaNPqShdPl9SxD5EB2XKRpfCCRJ",

  brands: [
    {
      name: "cxosignature",
      displayName: "cxosignature.com",
      url: "https://cxosignature.com/",
    },
    {
      name: "eventpopulation",
      displayName: "EventPopulation.com",
      url: "https://www.eventpopulation.com/",
    },
    {
      name: "cxosports",
      displayName: "CXOsports.com",
      url: "https://info.ciosynergy.com/ciosports/",
    },
    {
      name: "ciocamps",
      displayName: "ciocamps.com",
      url: "https://cio.cxosync.com",
    },
    {
      name: "cisocamps",
      displayName: "cisocamps.com",
      url: "https://ciso.cxosync.com",
    },
    {
      name: "cfocamps",
      displayName: "cfocamps.com",
      url: "https://cfo.cxosync.com",
    },
    {
      name: "cmocamps",
      displayName: "cmocamps.com",
      url: "https://cmo.cxosync.com",
    },
  ],

  contact: {
    name: "CXOsync",
    legalName: "CXOsync LLC",
    location: "Schaumburg, IL",
    email: "info@cxosync.com",
    inquiry: "inquiry@cxosync.com",
    phone: {
      us: "+1 (847) 278-2213",
      uk: "+44 (20) 39003149",
    },
    address: {
      street: "1900 E Golf Rd",
      city: "Schuamburg",
      state: "IL",
      country: "United States",
      zipCode: "60173",
    },
  },
  twitterHandle: `@${twitter}`,
  social: {
    facebook: "@",
    twitter: `${twitter}`,
    instagram: "",
    linkedin: `${linkedin}`,
  },
  socialMedia: [
    {
      name: "Linkedin",
      url: `https://www.linkedin.com/company/${linkedin}/`,
    },
    {
      name: "Instagram",
      url: "",
    },
    {
      name: "Twitter",
      url: `https://twitter.com/${twitter}`,
    },
  ],
  singlePageNav: [
    {
      name: "Upcoming Events",
      url: "#section-upcoming-events",
      section_ref : true
    },
    {
      name: "Sponsorship Options",
      url: "#section-sponsorship-options",
      section_ref : true
    },
    {
      name: "CXOstories",
      url: "https://cxostories.cxosync.com/",
      section_ref : false
    },
    {
      name: "Events Calendar",
      url: "/events/",
      section_ref : false
    },
  ],
  nav: [
    {
      name: "Events Calendar",
      url: "/events/",
      section_ref : false
    },
    // {
    //   name: "Options",
    //   url: "/options/",
    //   section_ref : false
    // },
    // {
    //   name: "Panels",
    //   url: "/panels/",
    // },
    // {
    //   name: "Testimonials",
    //   url: "/testimonials",
    // },
    // {
    //   name: "Partners",
    //   url: "/partners",
    // },
    // {
    //   name: "About",
    //   url: "/about",
    // },
  ],
  // onePageNav: [
  //   {
  //     name: "Packages",
  //     url: "#packages",
  //     offset: 80,
  //   },
  //   {
  //     name: "Format",
  //     url: "#format",
  //     offset: 40,
  //   },
  //   {
  //     name: "Insights",
  //     url: "#insights",
  //     offset: 20,
  //   },
  // ],
  brandsColors: {
    default: "#dc0000",
    cxosync: "#22518a",
    hr: "#22518a",
    cx: "#22518a",
    ciocamps: "#149cea",
    ciosynergy: "#149cea",
    fintechcio: "#149cea",
    ciohealth: "#0273b2",
    cisocamps: "#dc0000",
    secureciso: "#dc0000",
    fintechciso: "#dc0000",
    cmocamps: "#eb962d",
    cmoorg: "#eb962d",
    cmodinners: "#ec671b",
    cfocamps: "#47b946",
    cfoorg: "#47b946",
    merchantorg: "#f0823b",
    eps: "#00b3e2",
    cxosignature: "#9254FF",
    dinners: "#9254FF",
    cxosports: "#00ff00",
    cxostories: "#149cea",
    panels: "#149cea",
    notice: "#00ff00",
    white: "#ffffff",
  },
  headerHeight: 80,
  greenColor: "#64ffda",
  navyColor: "#0a192f",
  darkNavyColor: "#020c1b",
  typeform: {
    webinar: "D1zBOv",
    inperson: "GEgxkA",
  },
  poc: {
    toniannf: {
      name: "ToniAnn Fedele",
      email: "toniannf@cxosync.com",
      ext: "890",
    },
    dominicd: {
      name: "Dominic Dominguez",
      email: "dominicd@cxosync.com",
      ext: "",
    },
  },
  packages: {
    ciso: {
      gala: [
        {
          title: "Gala Sponsor",
          highlight: false,
          tag: false,
          tag_line: "",
          options: [
            {
              text: "2 Reps will attend the Dinner",
            },
            {
              text: "Live intro addressing the entire audience",
            },
            {
              text: "Host <b>roundtable discussions</b> with 5 - 8 pre-selected attendees",
            },
            {
              text: "Full contact details of attendees post event",
            },
            {
              text: "1-2 introductions in a networking environment (Limit 2 sponsors)",
            },
          ],
        },
        {
          title: "Gala + Content Sponsor",
          highlight: true,
          tag: false,
          tag_line: "Most Popular",
          options: [
            {
              text: "2 Reps will attend the Dinner",
            },
            {
              text: "Join the Panel",
            },
            {
              text: "Host <b>roundtable discussions</b> with 5 - 8 pre-selected attendees",
            },
            {
              text: "Full contact details of attendees post event",
            },
            {
              text: "1-2 introductions in a networking environment (Limit 2 sponsors)",
            },
          ],
        },
        {
          title: "Gala Access",
          highlight: false,
          tag: false,
          tag_line: "",
          options: [
            {
              text: "2 Reps will attend the Dinner",
            },
            {
              text: "Full access to the audience and Gala",
            },
            {
              text: "5k USD credit toward next event sponsorship",
            },
          ],
        },
      ],
      secureciso: [
        {
          title: "Access Pass",
          highlight: false,
          tag: false,
          tag_line: "",
          options: [
            {
              text: "1 representative will have full access to the event - seat in all presentations and gain access to attendees during networking sessions",
            },
            {
              text: "Post event this amount will be credited towards future sponsorship investment",
            },
          ],
        },
        {
          title: "Exhibit",
          highlight: false,
          tag: true,
          tag_line: "",
          options: [
            {
              text: "2 representatives will have full access to the event.",
            },
            {
              text: "<b>Showcase</b> during networking sessions",
            },
            {
              text: "Submit a question for onsite attendees to respond - receive attendee responses post event along with their contact details.",
            },
            {
              text: "Interact with attendees onsite through CXOsync App - obtain attendee email addresses of those your team check-in into the App.",
            },
          ],
        },
        {
          title: "Exhibit +  Content",
          highlight: false,
          tag: false,
          tag_line: "",
          options: [
            {
              text: "3 representatives will have access to the event",
            },
            {
              text: "20 min <b>speaking</b>",
            },
            {
              text: "6-8 AdHoc <b>1:1 meetings</b>",
            },
            {
              text: "<b>Showcase</b> during our networking sessions",
            },
            {
              text: "Receive full contact details of attendees post event",
            },
          ],
        },
        {
          title: "Premier",
          highlight: true,
          tag: true,
          tag_line: "Most Popular",
          options: [
            {
              text: "3 representatives will have access to the event",
            },
            {
              text: "Host <b>roundtable discussions</b> with 8 pre-selected attendee",
            },
            {
              text: "6-8 AdHoc <b>1:1 meetings</b>",
            },
            {
              text: "<b>Showcase</b> during our networking sessions",
            },
            {
              text: "CISOdraw will help your team set up post event meetings with attendees",
            },
            {
              text: "Submit a question for onsite attendees to respond - receive attendee responses post event along with their contact details.",
            },
            {
              text: "Receive full contact details of attendees post event",
            },
          ],
        },
        {
          title: "Premier + Content",
          highlight: false,
          tag: false,
          tag_line: "",
          options: [
            {
              text: "Pre-Qualify attendees around your offerings",
            },
            {
              text: "Join the Predictions panel as a panelist for a 20 min panel discussion on a topic of your choice",
            },
            {
              text: "4 representatives will have access to the event",
            },
            {
              text: "Plus all deliverables of Premier",
            },
          ],
        },
      ],
    },
  },
};
